module.exports = __webpack_public_path__ + "static/media/light-logo.a1fac91f.png";